 
import apiClient from "../apiInstance.js";
import { COMPLIANCE_STATS_URLS } from "../apiConfig.js";
import { COMPLIANCE_STATS_ERRORS } from "../../common/constants/dashboardModule/complianceStatsConstants.js";

export const fetchComplianceStatInfo = async (complianceType, complianceRuleID) => {
    try {
        const response = await apiClient.post(COMPLIANCE_STATS_URLS.GET_COMPLIANCE_STAT_INFO, { complianceType, complianceRuleID });
        return response.data;
    } catch (error) {
        console.error(COMPLIANCE_STATS_ERRORS.FETCH_COMPLIANCE_STATS_ERROR, error);
        throw error;
    }
};